import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from './firebaseConfig';
import HomePage from './components/HomePage';
import LoginForm from './components/LoginForm';
import Dashboard from './components/Dashboard';
import Register from "./components/Register";
import Subscription from "./components/Subscription";
import FlowTracker from "./components/FlowTracker";
import PersonalTraining from "./components/FlowTracker/PersonalTraining";
import Contact from "./components/Contact";
import Tutorials from "./components/Tutorials";
import PositiveAffirmations from "./components/PositiveAffirmations";
import Feedback from "./components/Feedback";
import Welcome from "./components/Welcome";
import EmailSent from "./components/emailSent";
import Pricing from "./components/Pricing";
import AboutUs from "./components/About";
import Account from "./components/Account";
import Admin from "./components/Admin";
import AccessDenied from "./components/AccessDenied";
import UnauthorizedPage from "./components/UnauthorizedPage";
import Cycles from "./components/Cycles";
import Experiences from "./components/Experiences";
import OverviewDashboard from "./components/OverviewDashboard";
import { AdminViewProvider } from './contexts/AdminViewContext';


function App() {
    const [user, loading] = useAuthState(firebase.auth());

    if (loading) {
        return <div></div>;
    }

    return (
        <AdminViewProvider>
            <Router>
                <Routes>
                <Route path="/" element={<HomePage user={user}/>} />
                <Route path="/emailSent" element={<EmailSent/>} />
                <Route path="/register" element={<Register />} />
                <Route path="/subscription" element={<Subscription />} />
                <Route path="/login" element={<LoginForm />} />
                <Route path="/About" element={<AboutUs user={user}/>} />
                <Route path="/contact" element={<Contact user={user} />} />
                <Route path="/pricing" element={<Pricing user={user} />} />
                <Route path="/welcome" element={<Welcome user={user} />} />
                <Route path="/unauthorized" element={<UnauthorizedPage/>} />
                <Route
                    path="/dashboard"
                    element={
                        user ? (
                            user.emailVerified ? (
                                <OverviewDashboard user={user} />
                            ) : (
                                <Navigate to="/emailSent" />
                            )
                        ) : (
                            <Navigate to="/unauthorized" />
                        )
                    }
                />
                <Route path="/overview" element={user ? user.emailVerified ? <OverviewDashboard user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/flow-state-habits" element={user ? user.emailVerified ? <Dashboard user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/cycles" element={user ? user.emailVerified ? <Cycles user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/experiences" element={user ? user.emailVerified? <Experiences user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/tutorials" element={user ? user.emailVerified? <Tutorials user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/positiveAffirmations" element={user ? user.emailVerified? <PositiveAffirmations user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/feedback" element={user ? user.emailVerified? <Feedback user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/flowtracker" element={user ? user.emailVerified? <FlowTracker user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/personalTraining" element={user ? user.emailVerified ? <PersonalTraining user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/account" element={user ? user.emailVerified ? <Account user={user} /> : <EmailSent/>: <UnauthorizedPage/>} />
                <Route path="/adminpanel" element={
                    user ? 
                        user.emailVerified ? 
                            <Admin user={user} /> 
                        : <EmailSent/>
                    : <UnauthorizedPage/>
                } />
                <Route path="/access-denied" element={<AccessDenied />} />
            </Routes>
            </Router>
        </AdminViewProvider>
    );
}

export default App;